
import { ButtonGroup, DropdownButton, Dropdown } from "react-bootstrap";
import {
    FaMicrochip, FaMapMarker, FaRoad,
    FaMap, FaBus, FaCarAlt, FaMotorcycle, FaLock, FaMobileAlt
} from "react-icons/fa";
import { HiOutlineStatusOnline, HiOutlineStatusOffline } from "react-icons/hi";
import { AiOutlineGateway } from "react-icons/ai";
// import { BASE } from "../http";
import { calculate_last_seen_time } from "../Utils";


export default function TrackerDisplay(props: any) {

    let asset_type = props.data.asset_type, icon;

    if (asset_type === 1) {
        icon = <FaMotorcycle title="motor cycle vehicle type" />
    }
    else if (asset_type === 2) {
        icon = <FaCarAlt title="motor car vehicle type" />
    }
    else if (asset_type === 3) {
        icon = <FaBus title="buses or truck vehicle type" />
    }
    else if (asset_type === 4) {
        icon = <FaMobileAlt title="mobile phone types" />
    }
    let location = {}

    for (var x = 0; x < props.loc.length; x++) {

        if (props.loc[x].device_info === props.data.device_info) {
            location = props.loc[x].latlng
            break
        }
    }

    let _title = "feature available on google map interface";
    let title_statement = calculate_last_seen_time(props.data.last_update);


    return (
        <tr>
            <td>
                {icon}
            </td>
            <td>
                <a className="nodecor text-grey bold" href="#"
                    data-attr={JSON.stringify(props.data)}
                    onClick={props.rider_focus}
                >
                    <b> {props.data.name} &nbsp;
                        {
                            props.data.last_update !== null && props.data.last_update < 21 && props.data.last_update > 0 ? (
                                <HiOutlineStatusOnline className={'dot'} color="#00b300" title={title_statement} size={20} />
                            ) : (
                                <HiOutlineStatusOffline color={'#cc0000'} className="dot" title={title_statement} size={20} />
                            )
                        }
                    </b>
                </a>

            </td>
            <td> {props.data.unique_id} </td>
            <td style={{ width: '5%' }}>
                <ButtonGroup className=''>

                    <DropdownButton title="" as={ButtonGroup} id="bg-nested-dropdown" variant={'link'}>

                        <Dropdown.Item eventKey="1" title='Position History' onClick={() => props.Movement(props.data)}>
                            <FaRoad />&nbsp;Movements
                        </Dropdown.Item>
                        <Dropdown.Divider />
                        <Dropdown.Item eventKey="2" onClick={() => props.LastPos(props.data.device_info)}
                            title='Last Found Position'>
                            <FaMapMarker /> &nbsp;Last Position
                        </Dropdown.Item>
                        <Dropdown.Divider />
                        <Dropdown.Item eventKey="3" onClick={() => props.getlocation(location)}>
                            <FaMap />&nbsp; Get Location
                        </Dropdown.Item>
                        <Dropdown.Divider />
                        <Dropdown.Item eventKey="4" onClick={() => props.traffic_func(props.data.device_info)}>
                            <FaMicrochip /> &nbsp; Simulate RealTime Traffic {props.locked ? <FaLock title={_title} /> : null}
                        </Dropdown.Item>
                        <Dropdown.Divider />
                        <Dropdown.Item eventKey="5" onClick={() => console.log("Geo fencingwas clicked")}>
                            <AiOutlineGateway /> &nbsp; Geo Fencing  {props.locked ? <FaLock title={_title} /> : null}
                        </Dropdown.Item>

                    </DropdownButton>

                </ButtonGroup>
            </td>
        </tr>
    )

}

export function StyleComponent() {

    const svgurl = process.env.REACT_APP_BASE + "/static/icon.svg";

    return (

        <style type="text/css">
            {`
            .dropdown-toggle::after {
                font-size: 20px;
                content: url(${svgurl});
                border-top: none;
            }    
        `}
        </style>
    )
}